import React, { useState } from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui, TextField } from 'components';
import { Drawer } from 'components/layouts';

// Local Components
import { Confirmation } from '../Dialogs';

function Bulk({ actions, showAsDropdown = false, dropdownProps = {} }) {
  // States
  const [currentAction, setCurrentAction] = useState(null);
  const currentActionData =
    actions.find(action => action.key === currentAction?.key) ?? currentAction;
  const { additionalAction, confirmAction } = currentActionData || {};

  return (
    <>
      <Mui.Box display="flex" alignItems="center" flexWrap="wrap" gridGap={10}>
        {showAsDropdown ? (
          <TextField
            select
            margin="none"
            value={currentAction?.key || ''}
            onChange={event => {
              const action = actions.find(item => item.key === event.target.value);
              setCurrentAction(action);
            }}
            SelectProps={{ native: true }}
            {...dropdownProps}>
            <option value="">Selecione uma ação</option>
            {actions.map(action => (
              <option key={action.key} value={action.key} disabled={action.disabled}>
                {action.title} ({action.lines?.length})
              </option>
            ))}
          </TextField>
        ) : (
          <>
            {actions.map(action => (
              <Mui.Button
                color="default"
                key={action.key}
                variant="outlined"
                size="small"
                startIcon={action.icon ? <Mui.Icon>{action.icon}</Mui.Icon> : null}
                onClick={() => setCurrentAction(action)}
                disabled={action.disabled}>
                <Mui.Box display="flex" justifyContent="space-between" alignItems="center">
                  <Mui.Box mr={1}>{action.title}</Mui.Box>
                  {!!action.lines?.length && (
                    <Mui.Chip size="small" variant="outlined" label={action.lines.length} />
                  )}
                </Mui.Box>
              </Mui.Button>
            ))}
          </>
        )}
      </Mui.Box>
      <Confirmation
        open={!!confirmAction}
        title={confirmAction?.title || undefined}
        onClose={() => setCurrentAction(null)}
        onConfirm={confirmAction?.action}>
        {confirmAction?.description || (
          <>
            Deseja executar a ação de{' '}
            <strong>{currentActionData?.title?.toLowerCase() || ''}</strong> para os itens
            selecionados?
          </>
        )}
      </Confirmation>
      <Drawer
        open={!!additionalAction}
        title={additionalAction?.title}
        width={additionalAction?.width || 600}
        description={additionalAction?.description || undefined}
        onClose={() => setCurrentAction(null)}>
        {!!additionalAction?.component && (
          <Mui.Container>
            {additionalAction.component({ onClose: () => setCurrentAction(null) })}
          </Mui.Container>
        )}
      </Drawer>
    </>
  );
}

Bulk.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      disabled: PropTypes.bool,
      lines: PropTypes.arrayOf(PropTypes.object),
      confirmAction: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        action: PropTypes.func.isRequired,
      }),
      additionalAction: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        component: PropTypes.func,
      }),
    }),
  ),
  showAsDropdown: PropTypes.bool,
  dropdownProps: PropTypes.object,
};

export default Bulk;
